import { useEffect } from "react";
import { useGlobalConfiguration } from "../../hooks/useGlobalConfiugration";
import { GLAUKOS_PROJECT_ID_PRODUCTION, GLAUKOS_PROJECT_ID_STAGING } from "../../main";

// Extend Window interface to include fbq
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}

/**
 * MetaPixel component that loads Facebook Pixel tracking script
 * only for the Glaukos project (both staging and production instances).
 */
export const MetaPixel = () => {
  const { projectId } = useGlobalConfiguration();

  useEffect(() => {
    // Check if current project is Glaukos (either staging or production)
    const isGlaukosProject = projectId === GLAUKOS_PROJECT_ID_PRODUCTION || projectId === GLAUKOS_PROJECT_ID_STAGING;

    if (!isGlaukosProject) {
      return;
    }

    // Check if Meta Pixel is already loaded
    if (window.fbq) {
      return;
    }

    // Load Meta Pixel script
    const script = document.createElement("script");
    script.setAttribute("data-meta-pixel", "glaukos");
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '840180478644442');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    // Add noscript fallback
    const noscript = document.createElement("noscript");
    noscript.setAttribute("data-meta-pixel-noscript", "glaukos");
    const img = document.createElement("img");
    img.height = 1;
    img.width = 1;
    img.style.display = "none";
    img.src = "https://www.facebook.com/tr?id=840180478644442&ev=PageView&noscript=1";
    noscript.appendChild(img);
    document.head.appendChild(noscript);

    // Cleanup function to remove scripts when component unmounts
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      if (noscript.parentNode) {
        noscript.parentNode.removeChild(noscript);
      }
    };
  }, [projectId]);

  return null;
};
